<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>

            <form-group horizontal name="title" :label="$t('attributes.name')">
              <b-input
                v-model="form.title"
                name="title"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="comment"
              :label="$t('attributes.comment')"
            >
              <b-input
                v-model="form.comment"
                name="comment"
                type="textarea"
                maxlength="50"
                :placeholder="
                  $t('message.please_input') + $t('attributes.comment')
                "
                expanded
              >
              </b-input>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              permissionGroup.id
                ? $t('attributes.update')
                : $t('attributes.add')
            }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'PermissionGroupForm',

  props: {
    permissionGroup: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean
    }
  },
  data() {
    return {
      form: this.extractFormValues(this.permissionGroup)
    }
  },
  validations: {
    form: {
      status: { required },
      title: { required, maxLength: maxLength(50) },
      comment: { maxLength: maxLength(50) }
    }
  },
  computed: {
    formTitle() {
      let title = this.permissionGroup.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.permission_group')

      return title
    },
    isLoading() {
      return this.sending
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        status: data.status,
        title: data.title,
        comment: data.comment
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
